import config from '../../../config';

export const SocketNotificationTypes = {
  LIVE_SCORE: 'LiveScore',
};

export const InvocationGroupTypes = {
  EVENT: 'event',
};

export const NotificationGroupTypeMap = {
  [SocketNotificationTypes.LIVE_SCORE]: [InvocationGroupTypes.EVENT],
};

export const isInvocationGroupTypeValidForNotificationType = (notificationType, invocationGroupType) => {
  return NotificationGroupTypeMap[notificationType]?.includes(invocationGroupType);
};

const connectionsStringMap = {
  [SocketNotificationTypes.LIVE_SCORE]: config.liveScoresApiHost,
};

export const getSignalRConnectionString = (type) => {
  if (!Object.values(SocketNotificationTypes).includes(type)) {
    console.error(`Notification type ${type} is not recognized.`);
    return null;
  }

  return connectionsStringMap[type];
};
